import React, { Fragment } from 'react';
import AccessCode from '../../common/accesscode/AccessCode';
import Error from '../../common/form/errorMessage';
import { ERROR_MESSAGES } from '../../common/form/constants/validationErrorMessages';

interface IAccessCodeNonExpandedViewProps {
    values: {
        accessCode: string;
    };
    i18nReplacements: {
        accessCode: JSX.Element;
        ssn:JSX.Element;
    };
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    handleFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
    errors: {
        accessCode?: {
            type: string;
        };
    };
}

export default function AccessCodeExpandedView({
    values,
    i18nReplacements,
    handleChange,
    handleBlur,
    handleFocus,
    errors,
}: IAccessCodeNonExpandedViewProps) {
    return (
        <Fragment>
            <AccessCode
                labelText="accounts.login_success.enter_access_code"
                labelClasses={['padding-l-0']}
                isRequired={false}
                wrapperClasses={['grid-row gi-accesscode margin-t-0']}
                inputClasses={['desktop:grid-col-8 tablet:grid-col-8 mobile:grid-col-8 grid-col-8']}
                value={values.accessCode}
                isInputRequired={false}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                maxLength={10}
                messageText={i18nReplacements.accessCode}
                errorWrapperClasses={['access-code__error__wrapper']}
                errorClasses={['margin-t-10']}
            />
            <Error
                isVisible={errors.accessCode && errors.accessCode.type === 'required'}
                messageText={ERROR_MESSAGES.REQUIRED}
                textReplacements={i18nReplacements.accessCode}
                errorWrapperClasses={['access-code__error__wrapper']}
                errorClasses={['center']}
            />
            <Error
                isVisible={errors.accessCode && errors.accessCode.type === 'exactLength'}
                messageText={ERROR_MESSAGES.NOT_VALID}
                textReplacements={i18nReplacements.accessCode}
                errorWrapperClasses={['access-code__error__wrapper', 'margin-tb-5']}
                errorClasses={['center']}
            />
        </Fragment>
    );
}
